import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthProvider, getBaseUrl } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import { useMaterialUIController } from "@cloudpremise/portal_core/src/themes/mui/context";
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import breakpoints from "@cloudpremise/portal_core/src/themes/mui/assets/theme/base/breakpoints";

//Tabs
import GlobalSettings from "./Tabs/Global";
import DeployedSites from "./Tabs/Sites";
import RoutingRules from "./Tabs/RoutingRules";

import Navbar from "../../components/Navbar";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import "../../styles/plugins.scss";

const Settings = (props) => {
    const [ authorized, authType, token ] = useAuthProvider();
    const [ controller ] = useMaterialUIController();
    const { config, user } = controller;
    const basename = getBaseUrl();
    const routeParams = useParams();
    let currentTab = "global";
    if(typeof(routeParams) === "object" && routeParams.hasOwnProperty("tab")){
        currentTab = routeParams.tab;
    }
    const defaultState = {
        search: "",
        tabs: [
            {
                name: "global",
                label: "Global Settings"
            },
            {
                name: "sites",
                label: "Deployed Sites"
            },
            {
                name: "rules",
                label: "Routing Rules"
            }
        ],
        tabsOrientation: "horizontal",
        currentTab: currentTab,
        loading: false,
        errorMessage: null
    };

    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);
    const navigate = useNavigate();
    React.useEffect(() => {
        if(!authorized){
            return navigate("/landing", { replace: true });
        }
    });

    React.useEffect(() => {
        // A function that sets the orientation state of the tabs.
        function handleTabsOrientation() {
          return window.innerWidth < breakpoints.values.sm
            ? setState({tabsOrientation: "vertical"})
            : setState({tabsOrientation: "horizontal"});
        }
    
        /** 
         The event listener that's calling the handleTabsOrientation function when resizing the window.
        */
        window.addEventListener("resize", handleTabsOrientation);
    
        // Call the handleTabsOrientation function to set the state with the initial value.
        handleTabsOrientation();
    
        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleTabsOrientation);
    }, [state.tabsOrientation]);

    function onTabChange(event, tab){
        setState({
            currentTab: tab
        });
        window.history.replaceState(null, document.title, basename+"/admin/iris/settings/"+tab+window.location.search);
    }
    function renderTab(tab){
        return (
            <Tab
                label={tab.label}
                value={tab.name}
                key={tab.name}
            />
        )
    }
    function renderTabs(){
        return (
            <Tabs
                orientation={state.tabsOrientation}
                value={state.currentTab}
                onChange={onTabChange}
            >
                {
                    state.tabs.map((tab) => {
                        return renderTab(tab)
                    })
                }
            </Tabs>
        )
    }
    function renderTabContents(){
        let tabContent = null;
        switch(state.currentTab){
            case 'global':
                tabContent = <GlobalSettings />;
                break;
            case 'sites':
                tabContent = <DeployedSites />;
                break;
            case 'rules':
                tabContent = <RoutingRules />;
                break;
            default:
                break;
        }
        return tabContent;
    }
    if(!authorized){
        return null;
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={config.hideLayout ? 0 : 3}>
                <Navbar />
                <MDBox mb={2}>
                    <MDTypography variant="h3">Iris Portal Settings</MDTypography>
                </MDBox>
                <MDBox>
                    {renderTabs()}
                </MDBox>
                <MDBox mt={2} className={"tab-"+state.currentTab}>
                    {renderTabContents()}
                </MDBox>
            </MDBox>
        </DashboardLayout>
    )
}

export default Settings;